import { render } from "./SelectBoxPairs.vue?vue&type=template&id=6e0bbd56&scoped=true&lang=pug"
import script from "./SelectBoxPairs.vue?vue&type=script&lang=js"
export * from "./SelectBoxPairs.vue?vue&type=script&lang=js"

import "./SelectBoxPairs.vue?vue&type=style&index=0&id=6e0bbd56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0bbd56"]])

export default __exports__